import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AssetRegisterPage from './AssetRegisterPage';
import AssetDetailPage from './AssetDetailPage';
import DepreciationWorkbenchPage from './DepreciationWorkbenchPage';
import AssetBlocksPage from './AssetBlocksPage';
import AssetReportsPage from './AssetReportsPage';

/**
 * Fixed Asset Management module router, mounted at /assets/* in App.tsx.
 *
 * Static sub-paths (depreciation, blocks, reports) are declared before the
 * dynamic `:id` route so "depreciation" etc. never gets parsed as an asset id.
 */
const AssetsPage: React.FC = () => (
  <Routes>
    <Route index element={<AssetRegisterPage />} />
    <Route path="depreciation" element={<DepreciationWorkbenchPage />} />
    <Route path="blocks" element={<AssetBlocksPage />} />
    <Route path="reports" element={<AssetReportsPage />} />
    <Route path=":id" element={<AssetDetailPage />} />
  </Routes>
);

export default AssetsPage;
